import { render, staticRenderFns } from "./StudentManage.vue?vue&type=template&id=6da89796&scoped=true"
import script from "./StudentManage.vue?vue&type=script&lang=js"
export * from "./StudentManage.vue?vue&type=script&lang=js"
import style0 from "./StudentManage.vue?vue&type=style&index=0&id=6da89796&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da89796",
  null
  
)

export default component.exports